import React from "react";
import { Paper, Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    minHeight: "12rem",
    height: "320px",
    display: "flex",
    width: "380px",
    borderRadius: "20px",
    // marginTop: "12px",
  },
  headerText: {
    fontWeight: "bold",
    fontSize: "26px",
    color: "#121212",
    fontFamily: "DM Sans",
  },
  textBody: {
    fontWeight: "400",
    color: "rgba(18, 18, 18, 0.7)",
    fontSize: "18px",
    fontFamily: "DM Sans",
    padding: "0 25px",
  },
}));

const IconBoxComponent = ({ icon: Icon, headerText, textBody }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper} elevation={0}>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Icon fill="#f4b547" height="35px" color="#f4b547" />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography align="center" className={classes.headerText}>
            {headerText}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography align="center" className={classes.textBody}>
            {textBody}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default IconBoxComponent;
